import Container, { Service } from "typedi";
import IHttpClientGetParameters from "../contracts/http-client/http-client-get-parameters.interface";
import IHttpClientPostParameters from "../contracts/http-client/http-client-post-parameters.interface";
import IHttpClientDeleteParameters from '@/modules/common/contracts/http-client/http-client-delete-parameters.interface'
import HttpClient from "./http-client.service";

@Service()
export default class RegisterService {
    public async createGroupRegistration (event_identifier: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/group`,
            requireToken: true
        }
        const response: any = await Container.get(HttpClient).post(httpParams, event_identifier)
        return response
    }

    public async addToGroupRegistration(event_identifier: string, group_uuid: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/group/${group_uuid}/participant/me`,
            requireToken: true
        }
        const response: any = await Container.get(HttpClient).post(httpParams, event_identifier)
        return response
    }

    public async addToA2ZGroupRegistration(event_identifier: string, group_uuid: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/group/${group_uuid}/a2z-additional-badge`,
            requireToken: true
        }
        const response: any = await Container.get(HttpClient).post(httpParams, event_identifier)
        return response
    }

    public async addA2ZAlottedBadgeAdhoc(event_identifier: string, group_uuid: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/group/${group_uuid}/a2z-add-allotted-badge`,
            requireToken: true
        }
        const response: any = await Container.get(HttpClient).post(httpParams, event_identifier)
        return response
    }

    public async getA2zData(event_identifier: string, group_uuid: string) {
        const httpParams: IHttpClientGetParameters = {
            url: `/event/${event_identifier}/group/${group_uuid}/a2z-data`,
            requireToken: true
        }
        const response: any = await Container.get(HttpClient).get(httpParams, event_identifier)
        return response
    }

    public async deleteGroupParticipantRegistrationSafe(payload: any) {
        const event_identifier = payload.eventIdentifier
        const data = payload.data
        const part = data.full_participant
        const group_uuid = part.participant_group_uuid
        const httpParams: IHttpClientDeleteParameters = {
            url: `/event/${event_identifier}/group/${group_uuid}/participant/${part.uuid}/safe`,
            requireToken: true,
            config: {
                data
            }
        }
        const response: any = await Container.get(HttpClient).delete(httpParams, event_identifier)
        return response
    }

    public async deleteA2ZGroupRegistration(event_identifier: string, group_uuid: string, data: any) {
        const httpParams: IHttpClientDeleteParameters = {
            url: `/event/${event_identifier}/group/${group_uuid}/a2z-additional-badge`,
            requireToken: true,
            config: {
                data
            }
        }
        const response: any = await Container.get(HttpClient).delete(httpParams, event_identifier)
        return response
    }

    public async getAllContent (event_identifier: string, reg_type: string) {
        const httpParams: IHttpClientGetParameters = {
            url: `/event/${event_identifier}/setup/${reg_type ? reg_type : 'default'}`,
            requireToken: false
        }
        const response: any = await Container.get(HttpClient).get(httpParams, event_identifier)
        return response
    }

    public async deleteParticipantFromGroup (event_uuid: string, group_uuid: string, participant_uuid: string) {
        const httpParams: IHttpClientDeleteParameters = {
            url: `/event/${event_uuid}/group/${group_uuid}/participant/${participant_uuid}`,
            requireToken: true
        }
        const response: any = await Container.get(HttpClient).delete(httpParams)
        return response
    }

    public async cancelRegistration(event_identifier: string, token: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/participant/me/cancel?auth_token=${token}`,
            requireToken: true
        }
        return await Container.get(HttpClient).post(httpParams, event_identifier)
    }

    public async idpStart(event_identifier: string, data: any) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/idp-start`,
            requireToken: true,
            payload: data
        }
        return await Container.get(HttpClient).post(httpParams, event_identifier)
    }

    public async idpReturnData(event_identifier: string, data: any) {
        const httpParams: IHttpClientPostParameters = {
            url: `/idp-return`,
            requireToken: true,
            payload: data
        }
        return await Container.get(HttpClient).post(httpParams, event_identifier)
    }


    public async idpChoose(event_identifier: string, data: any) {
        const httpParams: IHttpClientPostParameters = {
            url: `/idp-choose`,
            requireToken: true,
            payload: data
        }
        return await Container.get(HttpClient).post(httpParams, event_identifier)
    }
}
